'use client'

import { useEffect, useState } from 'react'
import { useRouter } from 'next/navigation'

export default function GlobalError({ error, reset }: any) {
    const router = useRouter()
    const [showDetail, setShowDetail] = useState(false)

    useEffect(() => {
        console.error('GLOBAL ERROR:', error)
    }, [error])

    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                fontFamily: 'sans-serif',
                padding: 20,
                textAlign: 'center',
            }}
        >
            <h1 style={{ fontSize: 24, color: 'red', marginBottom: 10 }}>
                🚨 Terjadi Kesalahan
            </h1>

            <p style={{ marginBottom: 10 }}>
                Aplikasi mengalami error. Silakan coba lagi atau kembali ke halaman utama.
            </p>

            {/* error message utama */}
            <p style={{ fontSize: 13, color: '#444', marginBottom: 10 }}>
                <b>Message:</b> {error?.message || 'Unknown error'}
            </p>

            {/* tombol toggle debug */}
            <button
                onClick={() => setShowDetail(!showDetail)}
                style={{
                    fontSize: 12,
                    marginBottom: 10,
                    padding: '6px 10px',
                    cursor: 'pointer'
                }}
            >
                {showDetail ? 'Hide Debug Info' : 'Show Debug Info'}
            </button>

            {/* DEBUG INFO (MENTAH) */}
            {showDetail && (
                <div
                    style={{
                        maxWidth: 700,
                        width: '100%',
                        textAlign: 'left',
                        background: '#111',
                        color: '#0f0',
                        padding: 15,
                        borderRadius: 6,
                        fontSize: 12,
                        overflowX: 'auto'
                    }}
                >
                    <div>
                        <b>NAME:</b> {error?.name}
                    </div>

                    <div style={{ marginTop: 8 }}>
                        <b>MESSAGE:</b>
                        <pre style={{ whiteSpace: 'pre-wrap' }}>
                            {error?.message}
                        </pre>
                    </div>

                    <div style={{ marginTop: 8 }}>
                        <b>STACK TRACE:</b>
                        <pre style={{ whiteSpace: 'pre-wrap' }}>
                            {error?.stack}
                        </pre>
                    </div>

                    <div style={{ marginTop: 8 }}>
                        <b>RAW ERROR OBJECT:</b>
                        <pre style={{ whiteSpace: 'pre-wrap' }}>
                            {JSON.stringify(error, null, 2)}
                        </pre>
                    </div>
                </div>
            )}

            {/* tombol action */}
            <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
                <button onClick={() => reset()}>
                    🔄 Coba Lagi
                </button>

                <button onClick={() => window.location.reload()}>
                    🔁 Reload
                </button>

                <button onClick={() => router.push('/')}>
                    🏠 Kembali ke Beranda
                </button>
            </div>
        </div>
    )
}